import axios from 'axios'
import { URL } from './config'

function getHeaders() {
    const headers = {
        'accept': 'application/json',
        'Content-Type': 'application/json',    
    }
    return headers
}

export const apiGet = (apiURL = '/URL_HERE', params = {}) => {
    const url = URL + apiURL
    const headerConfig = {
        headers: getHeaders(),
        params
    }
    return new Promise(async (resolve, reject) => {
        await axios.get(url, headerConfig)
            .then((data) => resolve(data))
            .catch((error) => {
                if (error.response) {
                    reject(error.response.data.detail)
                } else {
                    reject(error.message)
                }
            });
    });
};

export const apiPost = (apiURL = '/URL_HERE', data = {}) => {
    const url = URL + apiURL
    const headerConfig = { headers: getHeaders() }
    return new Promise(async (resolve, reject) => {
        await axios.post(url, data, headerConfig)
            .then((data) => resolve(data))
            .catch((error) => {
                if (error.response) {
                    reject(error.response.data.detail)
                } else {
                    reject(error.message)
                }
            });
    });
};